import { Controller } from "@hotwired/stimulus"

// statement-line — orquestra UMA linha da revisão por exceção da importação de
// fatura. A linha inteira é um form PATCH nested (statement_import_line); este
// controller apenas dispara o submit (Turbo Stream substitui a linha).
//
// Targets:
//   review — input hidden statement_import_line[review_status] (approved/rejected)
//
// A submissão é debounced em `save()` (edição de campo: categoria, valor, e os
// reembolsáveis do reimbursable-list cujo change borbulha até aqui) e imediata em
// `toggle()` (checkbox de importar).
export default class extends Controller {
  static targets = ["review"]

  // Checkbox "importar esta linha": alterna approved <-> rejected e salva.
  toggle() {
    const now = this.reviewTarget.value === "approved" ? "rejected" : "approved"
    this.reviewTarget.value = now
    // Feedback OTIMISTA: espelha a classe que a view usa para a linha desmarcada
    // (opacity-50), até o Turbo Stream trazer a linha re-renderizada do servidor.
    // Antes alternava "is-off", classe que não existe em CSS nenhum do projeto -
    // o clique não dava retorno visual até a resposta chegar.
    this.element.classList.toggle("opacity-50", now === "rejected")
    this.#submit()
  }

  // Auto-save de campos editáveis (categoria, valor, e os reembolsáveis rachados),
  // com debounce curto para agrupar digitação. O submit re-renderiza a linha a partir
  // do SERVIDOR (Turbo Stream) — os valores voltam formatados, sem corrupção do mask.
  save() {
    clearTimeout(this._t)
    this._t = setTimeout(() => this.#submit(), 500)
  }

  #submit() {
    clearTimeout(this._t)
    // CAUSA do "abre o select do 1º item / volta pra primeira": o turbo_stream.replace
    // destrói o <form> desta linha; se o foco ainda estava num campo dela, o navegador
    // MOVE o foco para o próximo focável — o 1º <select> da página —, que tem
    // openOnFocus e ABRE o dropdown sozinho (e rola até ele). Tirar o foco ANTES do
    // replace remove o alvo herdado: sem foco pendente, nada vaza para o 1º select.
    document.activeElement?.blur?.()
    // Cinto de segurança para o scroll (o replace ainda pode deslocar levemente).
    this.#lockScroll(window.scrollY)

    this.element.requestSubmit
      ? this.element.requestSubmit()
      : this.element.querySelector("[type=submit]")?.click()
  }

  // Mantém a janela em `y` por ~500ms (janela do replace + reconexão do Tom Select).
  // Para no primeiro wheel/touch do usuário (rolagem intencional) — não sequestra.
  #lockScroll(y) {
    if (this._unlock) this._unlock()
    let active = true
    const pin = () => { if (active && window.scrollY !== y) window.scrollTo(0, y) }
    const release = () => {
      active = false
      window.removeEventListener("scroll", pin)
      window.removeEventListener("wheel", release)
      window.removeEventListener("touchmove", release)
      clearTimeout(timer)
      this._unlock = null
    }
    window.addEventListener("scroll", pin)
    window.addEventListener("wheel", release, { passive: true, once: true })
    window.addEventListener("touchmove", release, { passive: true, once: true })
    const timer = setTimeout(release, 500)
    this._unlock = release
  }
}
